import React from "react";
import { Button } from "../Containers";
import constants from "../../constants";

const TableCertTicketId = (props) => ({
  Header: constants.labelAlias.tkt_id,
  accessor: (props && props.key) || "tkt_id",
  width: 100,
  Cell: (e) => (
    <Button
      flavor="blueLink"
      target={props && props.openNewTab === false ? "_self" : "_blank"}
      href={"/inquiries/certification/" + e.value}
      style={{ justifyContent: "flex-start" }}
    >
      {e.value}
    </Button>
  ),
});

export default TableCertTicketId;
